export const getProtocols = (state) => state.protocols
